module.exports = __webpack_public_path__ + "img/BE.4d4ebd4b.svg";